
(function(){
"use strict";
function ready(){
  document.querySelectorAll("[data-st-buy]").forEach(function(root){
    var options=Array.from(root.querySelectorAll("[data-st-variant-option]"));
    var form=root.querySelector("form");
    var add=root.querySelector("[data-st-add-to-cart]");
    var variantInput=root.querySelector("[data-st-variant-id]");
    var qty=root.querySelector("[data-st-quantity]");
    var price=document.querySelector("[data-st-product-price]");
    var status=document.querySelector("[data-st-product-availability]");
    var waitlist=root.querySelector("[data-st-waitlist]");
    var lowstock=document.querySelector("[data-st-lowstock]");
    var feedback=root.querySelector("[data-st-buy-feedback]");
    var controller=null;
    function writeState(source){
      var valid=!!source && source.dataset.variantId && source.dataset.variantId!=="";
      var available=valid&&source.dataset.available==="true";
      variantInput.value=valid?source.dataset.variantId:"";
      add.disabled=!available;
      add.textContent=available?"IN DEN WARENKORB ↗":valid?"AKTUELL AUSVERKAUFT":"AUSWAHL NICHT VERFÜGBAR";
      if(waitlist)waitlist.hidden=available;
      if(price&&valid&&source.dataset.price)price.textContent=source.dataset.price;
      var amount=valid?Number(source.dataset.quantity||0):0;
      if(lowstock){
        lowstock.hidden=!(available&&amount>0&&amount<=5);
        lowstock.textContent=lowstock.hidden?"":"Nur noch "+amount+" Stück in dieser Größe verfügbar";
      }
      if(qty){
        if(available&&amount>0){qty.max=String(amount);if(Number(qty.value)>amount)qty.value=String(amount);}
        else qty.removeAttribute("max");
      }
      if(status){
        var dot=status.querySelector(".st-pdp__availability-dot");
        status.textContent="";
        if(dot)status.appendChild(dot);
        status.appendChild(document.createTextNode(available?" VERFÜGBAR – JETZT BESTELLEN":" AUSVERKAUFT – DROP-BENACHRICHTIGUNG"));
      }
      if(feedback)feedback.textContent="";
    }
    options.forEach(function(sel){
      sel.addEventListener("change",async function(){
        if(controller)controller.abort();
        controller=new AbortController();
        var selected=options.map(function(x){return x.value}).filter(Boolean);
        if(!selected.length)return;
        add.disabled=true;add.textContent="AUSWAHL PRÜFEN …";
        if(feedback)feedback.textContent="";
        var url=new URL(root.dataset.productUrl,window.location.origin);
        url.searchParams.set("section_id",root.dataset.sectionId);
        url.searchParams.set("option_values",selected.join(","));
        var current=new URL(window.location.href);
        ["preview_theme_id","country","currency"].forEach(function(k){if(current.searchParams.has(k))url.searchParams.set(k,current.searchParams.get(k))});
        try {
          var response=await fetch(url.toString(),{credentials:"same-origin",signal:controller.signal});
          if(!response.ok)throw new Error("Shopify Section Rendering "+response.status);
          var html=new DOMParser().parseFromString(await response.text(),"text/html");
          var state=html.querySelector("[data-st-variant-state]");
          if(!state)throw new Error("Keine Variantendaten");
          writeState(state);
          if(state.dataset.variantId){
            var productUrl=new URL(root.dataset.productUrl,window.location.origin);
            productUrl.searchParams.set("variant",state.dataset.variantId);
            ["preview_theme_id","country","currency"].forEach(function(k){if(current.searchParams.has(k))productUrl.searchParams.set(k,current.searchParams.get(k))});
            window.history.replaceState(null,"",productUrl.pathname+productUrl.search);
          }
        }catch(e){
          if(e.name==="AbortError")return;
          add.disabled=true;
          add.textContent="AUSWAHL ERNEUT PRÜFEN";
          if(feedback)feedback.textContent="Auswahl konnte nicht geladen werden. Bitte erneut wählen.";
        }
      });
    });
    form.addEventListener("submit",function(e){
      if(!variantInput.value||add.disabled){e.preventDefault();if(feedback)feedback.textContent="Bitte eine verfügbare Variante wählen."}
    });
  });
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",ready);else ready();
})();
